import { useMutation, useQueryClient } from 'react-query';
import { DRAFT_NAME_CHANGE_DOCUMENT_TYPE } from 'shared/constants';
import { useService } from 'shared/providers';
import { CustomerNameChange } from 'shared/types';

export function useUpdateDraftNameChange() {
  const queryClient = useQueryClient();
  const { draftNameChangeService } = useService();
  const mutation = useMutation<{ operationId: string }, Error, CustomerNameChange>(
    request => draftNameChangeService.updateDraftNameChange(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(DRAFT_NAME_CHANGE_DOCUMENT_TYPE);
      },
    }
  );

  return mutation;
}
